import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useModelMeshStore } from '../state/store'

const useModelVisibilityV2 = (hiddenGuids: string[], stateId?: string) => {
  const addHiddenGuids = useModelMeshStore(state => state.addHiddenGuids)
  const removeHiddenGuids = useModelMeshStore(state => state.removeHiddenGuids)

  useLayoutEffect(() => {
    const uuid = stateId || v4()

    if (hiddenGuids.length) {
      addHiddenGuids(uuid, hiddenGuids)
    }

    return () => removeHiddenGuids(uuid)
  }, [addHiddenGuids, hiddenGuids, removeHiddenGuids, stateId])
}

export default useModelVisibilityV2
